import { apiClient } from './apiClient';

export interface RangeGeoJSON {
  type: 'Feature';
  geometry: {
    type: string;
    coordinates: unknown;
  };
  properties: {
    id: number;
    documentId: number;
    title: string;
    summary: string | null;
    routeCount: string;
  };
}

/**
 * API pour les zones/massifs
 */
export const areasApi = {
  /**
   * Récupère les massifs au format GeoJSON
   */
  async getRangesGeoJSON(): Promise<RangeGeoJSON[]> {
    return apiClient.get<RangeGeoJSON[]>('/areas/ranges/geojson');
  },
};
